import { useRef, useState } from 'react';
import { easeOut } from '@utils/constants';

const PROGRESS_TRANSITION_DURATION = 500;
const useProgress = () => {
  const animationFrameRef = useRef(undefined);
  const isRunning = useRef(false);
  const [progress, setProgress] = useState(undefined);

  // helper that'll gracefully update progress over a 350ms period, so we don't
  // see the progress jumping unexpectedly
  const transitionToProgress = nextProgress => {
    isRunning.current = true;
    if (animationFrameRef.current !== undefined) {
      cancelAnimationFrame(animationFrameRef.current);
    }
    const startedTransitioningAt = Date.now();
    let prevProgress;

    // cache previous value of progress so that we can transition from there
    setProgress(progress => {
      prevProgress = progress ?? 0;
      const handleAnimationFrame = () => {
        if (!isRunning.current) {
          return;
        }
        const p = easeOut(Math.min(1, (Date.now() - startedTransitioningAt) / PROGRESS_TRANSITION_DURATION), 2);
        const currProgress = prevProgress + (nextProgress - prevProgress) * p;
        setProgress(currProgress);
        if (p < 1) {
          animationFrameRef.current = requestAnimationFrame(handleAnimationFrame);
        } else {
          isRunning.current = false;
        }
      };
      handleAnimationFrame();
      return prevProgress;
    });
  };

  // completely reset progress
  const resetProgress = () => {
    isRunning.current = false;
    if (animationFrameRef.current !== undefined) {
      cancelAnimationFrame(animationFrameRef.current);
    }
    setProgress(undefined);
  };
  return [progress, transitionToProgress, resetProgress];
};

export { PROGRESS_TRANSITION_DURATION, useProgress };
//# sourceMappingURL=hook.progress.js.map
